import React, { useState } from 'react';
import { injectIntl } from 'react-intl';

import ActionButton from './ActionButton';
import ActionLink from './ActionLink';

const FloatingSelectorList = (props) => {
	const [ visible, setVisible ] = useState(false);

	const button_label = props?.button_label ?? "Create item";

	let classname = props?.classname ?? 'gui_floating_selector_list gui_pos_rel';
	let classes = classname.split(" ");

	if(props._class) {
		for(var i in props._class) classes.push(props._class[i]);
	}
	if(visible) classes.push('is_opened');
	if(props.opener_target != undefined) {
		classes.push('knk-more-options-h with_custom_opener');
	}

	const child = props.children;
	
	return (
		<div
			class={classes.join(" ")}
			onMouseEnter={() => setVisible(true)}
			onMouseLeave={() => setVisible(false)}
		>
			{(props.opener_target != undefined) ? (
				<span>{props.opener_target}</span>
			) : (
				<ActionButton
					_class={{other:'addButton'}}
				>{button_label}</ActionButton>
			)}

			{(visible) && (
				<nav class="nav_cont">
					<ul class="this_menu">
						{(props?._elements ?? []).map((e, k) => {
							if(e.status != undefined && !e.status) return null;

							if(child) {
								return React.cloneElement(child, { e:e, key:k });
							}

							return (
								<li key={k}>
									<ActionLink
										icon={e.icon}
										onClick={e.action}
									>{e.label}</ActionLink>
								</li>
							)
						})}
					</ul>
				</nav>
			)}
		</div>
	);
}

export default injectIntl(FloatingSelectorList);